import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import React, { useEffect } from 'react';

type Props = {
  title: string;
};

export default function Header(props: Props) {
  const { title } = props;
  const { auth, unread_log_count } = usePage().props;

  const profileDropdownRef = React.useRef<HTMLDivElement>(null);
  const mobileMenuDropdownRef = React.useRef<HTMLDivElement>(null);
  const mobileMenuButtonRef = React.useRef<HTMLDivElement>(null);

  const [isDropdownMenuOpen, setIsDropdownMenuOpen] = React.useState<boolean>(false);

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  useEffect(() => {
    const intervalFunction = () => Inertia.reload({ only: ['unread_log_count'] });

    const handler = setInterval(intervalFunction, 5000);

    return () => clearInterval(handler);
  }, []);

  return (
    <nav className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 5439.6 1882"
                className="text-indigo-600 h-16 py-3">
                <path
                  fill="currentColor"
                  d="M1760.6 1603.5c-9.5 136.9-22.1 186.4-101 186.4-22.1 0-69.4-8.8-104.1-8.8-22.1 0-28.4 14.6-28.4 29.1s6.3 26.2 28.4 26.2c116.7 0 274.5-5.8 520.6-5.8 280.8 0 508 5.8 627.9 5.8 18.9 0 28.4-11.7 28.4-26.2 0-11.7-9.5-26.2-28.4-26.2-25.2 0-60 5.8-75.7 5.8-78.9 0-94.6-49.5-101-186.4-6.3-203.9-15.8-498.1-15.8-789.4 0-203.9 3.1-410.7 15.8-582.6 6.3-93.2 12.6-183.5 91.5-183.5 31.5 0 63.1 8.7 85.2 8.7 18.9 0 28.4-17.5 28.4-29.1 0-14.6-9.5-26.2-28.4-26.2-151.4 0-334.4 11.6-508 11.6-208.2 0-290.3-11.6-416.5-11.6-85.2 0-97.8 23.3-107.3 75.7-53.6 335-104.1 501-173.5 745.7-28.4 99-50.5 160.2-101 160.2-47.3 0-75.7-55.4-116.7-218.5-44.2-168.9-97.8-512.6-113.6-672.8-9.5-72.8-31.6-90.3-91.5-90.3-183 0-271.3 11.6-533.2 11.6-148.3.2-350.2-11.5-514.3-11.5C9.5 1.4 0 13.1 0 27.7c0 11.6 9.5 29.1 28.4 29.1 22.1 0 53.6-8.7 85.2-8.7 104.1 0 119.9 102 119.9 215.5 0 763.2-69.4 1337-189.3 1485.6-28.4 37.9-41 43.7-41 64.1 0 14.6 9.5 23.3 25.3 23.3 56.8 0 154.6-5.8 280.8-5.8 186.1 0 287.1 5.8 350.2 5.8 22.1 0 31.5-17.5 31.5-26.2 0-20.4-9.5-29.1-72.6-84.5-224-195.2-337.6-681.6-337.6-1208.8 0-75.8 3.2-142.7 47.3-142.7 28.4 0 50.5 32 75.7 81.6 119.9 235.9 331.3 923.4 429.1 1255.4 31.5 107.8 41 122.3 249.3 122.3 217.7 0 252.4-14.6 274.5-122.3 88.4-436.9 208.3-996.2 293.4-1235.1 28.4-75.8 59.9-110.7 85.2-110.7 44.1 0 47.3 40.8 47.3 128.2 0 637.8-9.4 943.7-22 1109.7M3912.3 684.5c0-291.3 50.5-469 148.3-469 72.6 0 101 78.6 189.3 387.4 75.7 259.2 113.6 416.5 113.6 515.6 0 52.4-22.1 87.4-170.4 87.4-214.6 0-280.8-26.2-280.8-521.4m-154.7 1133.1c97.8 0 309.3 20.4 350.3 20.4 25.3 0 37.9-17.5 37.9-40.8 0-78.6-132.5-282.5-132.5-457.3 0-67 34.7-93.2 189.3-93.2 186.2 0 208.3 23.3 208.3 326.2 0 145.6-31.6 218.5-85.2 218.5-31.6 0-56.8-8.7-78.9-8.7-18.9 0-31.5 11.6-31.5 29.1 0 14.6 6.3 26.2 31.5 26.2 41 0 460.7-14.6 643.8-14.6 224 0 438.6 14.6 527 14.6 15.8 0 22.1-11.6 22.1-26.2 0-11.6-6.3-23.3-15.8-46.6-202-364.1-495.4-1293.3-495.4-1712.8 0-34.9-22.1-49.5-53.7-49.5-60 0-306.1 17.5-571.2 17.5C4092.1 20.4 3498 0 3390.8 0c-25.2 0-34.7 14.6-34.7 29.1 0 14.6 9.5 32.1 34.7 32.1 37.9 0 294.3-11.7 335.3-11.7 91.5 0 179.9 29.1 179.9 206.8 0 375.7-558.5 1147.7-558.5 1529.3 0 40.8 25.3 52.4 69.4 52.4 69.4 0 211.3-20.4 340.7-20.4M2892.1 1757.7h335.4v-49.4h-379.9V1882h44.5v-124.3zm58.6-167.7v-123.7l195.9 62.4-195.9 61.3zm-103.1 87.4l379.9-131.3v-35.8l-379.9-130.8v52.1l58.1 19.5v154.1l-58.1 20.1v52.1zm379.9-238.9v-52.1l-298.5-98.2 298.5-98.8v-52.1l-379.9 133v35.8l379.9 132.4zm-379.9-342.2h379.9v-51h-379.9v51zm0-237.4v49.4H3183v98.8h44.5V760.6H3183v98.2h-335.4zm121-360.9c-80.9 0-129.7 58.1-129.7 131.3 0 72.2 40.2 128.6 114.5 128.6 73.8 0 96.6-67.8 115.6-126.4 10.9-36.4 24.4-70.6 65.7-70.6 35.3 0 57 28.2 57 70 0 42.3-28.2 68.4-71.6 68.9v49.4c70-.6 116.1-50.5 116.1-119.4 0-68.4-41.2-118.3-101.5-118.3-77.1 0-96.1 56.4-117.8 124.8-9.8 33.1-22.8 72.2-68.9 72.2-39.6 0-64.6-31.5-64.6-75.4 0-51.5 33.1-85.8 85.2-85.8V498zm214.4-26h44.5V258.6h-379.9V472h44.5V308h122.1v164h44.5V308H3183v164zm0-257.2h44.5V1.4h-379.9v49.4h155.2v163.9h44.5V50.8H3183v164z"></path>
              </svg>
            </div>
            <div className="hidden sm:ml-6 sm:flex">
              <UserMenuItem href="/activities/volunteer_overview"> Activities</UserMenuItem>
              <UserMenuItem href="/activities/volunteer_log">
                Logs
                {!!unread_log_count && (
                  <span className="text-sm text-indigo-500 ml-1">({unread_log_count} Unread)</span>
                )}
              </UserMenuItem>
            </div>
          </div>

          <div className="hidden sm:ml-6 sm:flex sm:items-center">
            <div className="flex-1 px-4 flex justify-end">
              <div className="ml-4 flex items-center md:ml-6">
                <div className="ml-3 relative">
                  <div ref={profileDropdownRef}>
                    <button
                      onClick={() => setIsDropdownMenuOpen(!isDropdownMenuOpen)}
                      className="max-w-xs flex items-center focus:outline-none">
                      <div className="flex items-center">
                        <svg
                          className="text-indigo-600 mr-1"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <p className="text-indigo-600 font-medium">{auth.user.username}</p>
                      </div>
                    </button>

                    {isDropdownMenuOpen && (
                      <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg z-50">
                        <div className="py-1 rounded-md bg-white shadow-xs ">
                          <div
                            onClick={signOut}
                            className="block cursor-pointer z-50 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150">
                            Sign out
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div ref={mobileMenuButtonRef} className="-mr-2 flex items-center sm:hidden">
            <button
              onClick={() => setIsDropdownMenuOpen(!isDropdownMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out">
              <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                <path
                  className={`${isDropdownMenuOpen ? 'hidden' : 'inline-flex'}`}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
                <path
                  className={`${isDropdownMenuOpen ? 'inline-flex' : 'hidden'}`}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div
        ref={mobileMenuDropdownRef}
        className={`sm:hidden ${isDropdownMenuOpen ? 'block' : 'hidden'}`}>
        <div className="pt-2 pb-3">
          <UserMenuItem href="/activities/volunteer_overview">Activities</UserMenuItem>
          <UserMenuItem href="/activities/volunteer_logs">Logs</UserMenuItem>
        </div>
        <div className="pt-4 pb-3 border-t border-gray-200">
          <div className="flex items-center px-4">
            <svg
              className="text-gray-600"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="text-base ml-1 font-medium leading-6 text-gray-600">
              {auth.user.username}
            </div>
          </div>
          <div className="mt-3">
            <div
              onClick={signOut}
              className="mt-1 cursor-pointer block px-4 py-2 text-base font-medium text-red-500 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:text-gray-800 focus:bg-gray-100 transition duration-150 ease-in-out">
              Sign out
            </div>
          </div>
        </div>
      </div>
    </nav>
  );

  function handleClick(event: any) {
    if (
      (profileDropdownRef &&
        profileDropdownRef.current &&
        profileDropdownRef.current.contains(event.target)) ||
      (mobileMenuDropdownRef &&
        mobileMenuDropdownRef.current &&
        mobileMenuDropdownRef.current.contains(event.target)) ||
      (mobileMenuButtonRef &&
        mobileMenuButtonRef.current &&
        mobileMenuButtonRef.current.contains(event.target))
    ) {
      return;
    }

    setIsDropdownMenuOpen(false);
  }

  function signOut() {
    Inertia.delete('/sessions/destroy');
  }
}

function UserMenuItem(props) {
  const { children, href } = props;

  const { url } = usePage();

  const isActive = url.startsWith(href);

  const activeClasses = isActive
    ? 'bg-indigo-50 border-indigo-500 text-indigo-700'
    : 'text-gray-600';

  return (
    <InertiaLink
      className={`block pl-3 pr-4 py-2 text-base border-l-4 font-medium ${activeClasses}`}
      href={href}>
      {children}
    </InertiaLink>
  );
}
